import { Badge, Box, Button, Container, ExpandableSection, Form, FormField, Header, Link, Popover, SpaceBetween, Table } from '@cloudscape-design/components';
import { mdiAccountMultiple, mdiCertificateOutline, mdiDelete, mdiHumanMaleBoard, mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useRef, useState } from 'react';

import { isMobileDevice } from '../../pages/commons/functions';

import { parse, startOfDay } from 'date-fns';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemBooking } from '../../resources/types';
import BadgeCustom from '../extras/BadgeCustom';
import { ConfirmDelete } from '../extras/ConfirmDelete';
import RangeSlider from '../extras/RangleSlider';
import UserAvatar from '../extras/UserAvatar';
import HorizontalRule from '../HorizontalRule';


type RowItem = ItemBooking & {
    isParent?: boolean;
    children?: ItemBooking[];
};
type variant = 'mobile' | 'full' | 'auto';

interface TableBookingsProps {
    visible: boolean;
    variant?: variant;
    bookings: ItemBooking[];
    date?: string;
    range?: boolean;
    headers?: boolean;
    canDelete?: boolean;
    click?: boolean;
    filter?: React.ReactNode;
    bookingUrl?: string;
    //onMMounted: (ref: React.RefObject<HTMLDivElement>) => void;
    onBookingClick: (book: ItemBooking) => void;
    onBookingDelete?: (book: ItemBooking) => void;
}

const TableBookings: React.FC<TableBookingsProps> = ({
    visible,
    bookings,
    date = "",
    variant = "auto",
    range = true,
    filter = null,
    headers = true,
    click = false,
    canDelete = false,
    bookingUrl = "",
    onBookingClick,
    onBookingDelete
}) => {
    // Group bookings by groupType

    const localVariant = variant === "auto" ? (window.innerWidth < 768 || isMobileDevice() ? "mobile" : "full") : variant;
    const { idUser } = useGlobalState();
    const [showConfirm, setShowConfirm] = useState(false);
    const [booking, setBooking] = useState<ItemBooking | null>(null);
    const grouped = bookings.reduce((acc, booking) => {
        if (!acc[booking.groupType]) acc[booking.groupType] = [];
        acc[booking.groupType].push(booking);
        return acc;
    }, {} as Record<string, ItemBooking[]>);

    const towType = {
        MOUNTAIN: <BadgeCustom color="lime">Cordillera</BadgeCustom>,
        SANRAMON: <BadgeCustom color="violet">San Ramón</BadgeCustom>,
        LOCAL: <BadgeCustom color="brown">Local</BadgeCustom>,
        NONE: <BadgeCustom color="grey">Aº Despegue</BadgeCustom>,
        BALLAST: <BadgeCustom color="violet">Lastre</BadgeCustom>
    }
    // Flatten: insert parent row, then all children
    const tableItems: RowItem[] = [];

    if (headers) {
        Object.entries(grouped).forEach(([groupType, groupBookings]) => {
            tableItems.push({
                idBooking: `parent-${groupType}` as any,
                idBookingType: 0,
                idEquipment: 0,
                idUserPilot: 0,
                obsBooking: "",
                idUserInstructor: 0,
                displayName: '', // no user name for parent
                registration: groupType, // show groupType in "Equipo"
                bookingType: '',
                timeStart: '',
                timeEnd: '',
                dateSubmited: '',
                timeSubmited: '',
                towType: 'NONE',
                obs: '',
                instructor: '',
                groupType,
                idGroupType: groupBookings[0]?.idGroupType || 0,
                isParent: true,
                children: groupBookings,
                dateStart: '',
                dateEnd: '',
                minBookHour: 0,
                maxBookHour: 23,
                pax: 0,
                equipment: "",
                bookingTypeBadge: "grey",
                canDelete: 0,
                thresholdAfter: 0,
                thresholdBefore: 0,
                idUser: 0
            });
            tableItems.push(...groupBookings);

        });
    } else {
        tableItems.push(
            ...bookings.map(b => ({
                ...b,
                isParent: false
            }))
        );
    }
    const tableRef = useRef<HTMLDivElement>(null);

    const deleteIcon = (item: any) => item.canDelete === 1 && item?.idUser === idUser ? (
        <Link
            ariaLabel={`Eliminar reserva ${item.registration}`}
            onClick={() => {
                setBooking(item);
                setShowConfirm(true);
            }}
        >
            <Icon path={mdiDelete} size={1} color={"black"} />
        </Link>
    ) : null;
    const distinctBookingTypes = [
        // 3. Spread the Set back into a new array
        ...new Set(
            // 1. Map the array to extract only the BookingType values
            bookings.map((item) => item.bookingType)
        ),
    ];

    return (
        <SpaceBetween direction='vertical' size='xs'>

            {localVariant === "mobile" ?
                <>
                    {filter}

                    {bookings && bookings.length > 0 && (
                        Object.entries(grouped).map(([groupType, groupBookings], index) => (
                            <ExpandableSection key={groupType} variant="default" headerText={`${groupType}`}
                                defaultExpanded={index === 0}
                                onChange={(event) => {
                                }}
                                headerActions={
                                    <SpaceBetween size="xs" direction='horizontal'>


                                        {groupBookings?.reduce((sum, child) => sum + (child.pax || 0), 0) ?? 0 > 0 ?
                                            <Badge key={`PAX${groupType}`} color="green">
                                                {groupBookings?.reduce((sum, child) => sum + (child.pax || 0), 0) ?? 0}<Icon path={mdiAccountMultiple} size={0.6} />
                                            </Badge>
                                            : null}
                                        <Badge color="blue">{groupBookings.length}</Badge>
                                        {bookingUrl !== "" && parse(date, 'dd-MM-yyyy', new Date()) >= startOfDay(new Date()) && (
                                            <Link
                                                onClick={() => {
                                                    window.location.hash = `${bookingUrl}?date=${date}&idGroupType=${groupBookings[0]?.idGroupType || ""}`;
                                                }}>
                                                <Badge style={{}} color="blue"
                                                >{"RSV"}</Badge>
                                            </Link>
                                        )}
                                    </SpaceBetween>

                                }
                            >
                                <SpaceBetween direction="vertical" size="l" key={`ES${groupType}-${index}`}>
                                    {groupBookings.map((item) => (
                                        <Container key={`CT${item.idBooking}`} header={
                                            // 🎯 ADDED KEY HERE
                                            <Header key={`HDR${item.idBooking}`} variant="h3"
                                                // Corrected actions prop:

                                                actions={
                                                    <SpaceBetween direction="horizontal" size="xs" key={`SP1${item.idBooking}`}>
                                                        {item.equipmentType === "GLIDER" && (
                                                            <div key={`DV${item.idBooking}`}>{towType[item.towType as keyof typeof towType]}</div>
                                                        )}
                                                        <BadgeCustom key={`BT${item.idBooking}`} color={item.bookingTypeBadge}>{item.bookingType}</BadgeCustom>

                                                        {item.obsBooking && item.obsBooking !== '' ? (
                                                            <Popover
                                                                triggerType="custom"
                                                                // 🔑 CRITICAL FIX: Add the key here!
                                                                key={`POPOVER${item.idBooking}`}
                                                                dismissButton={false}
                                                                position="top"
                                                                size="small"
                                                                header='Observaciones'
                                                                content={item?.obsBooking}
                                                            >
                                                                <BadgeCustom color="grey" key={`OBS${item.idBooking}`}>
                                                                    <Icon path={mdiInformation} size={0.75} />
                                                                </BadgeCustom>
                                                            </Popover>

                                                        ) : null}
                                                        {item.pax > 0 ? <BadgeCustom color="grey" key={`OBS${item.idBooking}`}><Icon path={mdiAccountMultiple} size={0.6} />X{item.pax}</BadgeCustom> : null}
                                                    </SpaceBetween>
                                                }
                                            >
                                                <SpaceBetween direction="vertical" size="xs" key={`CT2${item.idBooking}`}>

                                                    <Link variant="awsui-value-large" key={`REG${item.idBooking}`}>{item.equipment === '' ? item.registration : item.equipment}</Link>

                                                </SpaceBetween>
                                            </Header>
                                        }>
                                            <SpaceBetween direction="vertical" size="xs" key={`SB${item.idBooking}`}>
                                                {/* 💡 ADDED KEY HERE */}
                                                <Form key={`FORM${item.idBooking}`}
                                                    actions=
                                                    {item.canDelete === 1 && item?.idUser === idUser ? (

                                                        <div key={`SUB${item.idBooking}`} onClick={() => {
                                                            setBooking(item);
                                                            setShowConfirm(true);
                                                        }}>
                                                            <Icon path={mdiDelete} size={1} color={"black"} />
                                                        </div>
                                                    ) : null}
                                                >
                                                    <SpaceBetween direction="horizontal" size="xs" key={`INST${item.idBooking}`}>

                                                        <UserAvatar idUser={item.idUser} width={30} />
                                                        <strong>{item.displayName}</strong>

                                                        {
                                                            item.instructor && item.instructor !== '' ? (
                                                                <Box>
                                                                    <Icon path={mdiHumanMaleBoard} size={1} /> {item.instructor}
                                                                </Box>
                                                            ) : null}
                                                    </SpaceBetween>
                                                    <HorizontalRule height={1} />
                                                    {/* Content inside Form uses keys correctly */}
                                                    {!range && (
                                                        <div key={`R1${item.idBooking}`}>
                                                            {item.dateStart !== item.dateEnd
                                                                ? `${item.dateStart} ${item.timeStart} - ${item.dateEnd} ${item.timeEnd}`
                                                                : `${item.dateStart} ${item.timeStart} - ${item.timeEnd}`}
                                                        </div>
                                                    )}

                                                    {range && (
                                                        <div key={`RS${item.idBooking}`}>
                                                            <RangeSlider
                                                                evtEndTH={item.thresholdAfter}
                                                                evtStartTH={item.thresholdBefore}
                                                                marginVertical={0}
                                                                date={date}
                                                                evtStart={`${item.dateStart} ${item.timeStart}`}
                                                                evtEnd={`${item.dateEnd} ${item.timeEnd}`}
                                                                start={item.minBookHour}
                                                                end={item.maxBookHour}
                                                            />
                                                        </div>
                                                    )}
                                                </Form>
                                            </SpaceBetween>
                                        </Container>
                                    ))}
                                </SpaceBetween>
                            </ExpandableSection >

                        ))
                    )}

                </>
                :
                <div ref={tableRef}>
                    <Table
                        filter={filter}
                        variant="embedded"
                        stickyHeader
                        wrapLines
                        onRowClick={({ detail }) => {
                            if (!detail.item.isParent) {
                                onBookingClick(detail.item);
                            }
                        }}
                        columnDefinitions={[

                            {
                                id: 'avatar',
                                header: "",
                                verticalAlign: 'top',
                                maxWidth: 15,
                                cell: (item: RowItem) => (
                                    item.isParent && item.children
                                        ? ""
                                        : (
                                            <UserAvatar idUser={item.idUser} width={30} tooltip={false} />
                                        )
                                ),

                            },
                            {
                                id: 'idBooking',
                                header: <FormField label='Material' >Identificador</FormField>,
                                verticalAlign: 'top',
                                minWidth: 120,
                                cell: (item: RowItem) => (
                                    item.isParent && item.children
                                        ? null
                                        : (
                                            <SpaceBetween direction="vertical" size="xs">
                                                <FormField
                                                    description={item.idBooking}
                                                    label={
                                                        click ? (
                                                            <>
                                                                <Link onClick={() => onBookingClick(item)}>
                                                                    {item.equipment && item.equipment !== "" ? item.equipment : item.registration}
                                                                </Link>
                                                                {deleteIcon(item)}
                                                            </>
                                                        ) : (
                                                            item.equipment !== "" ?
                                                                (<>{item.equipment} {deleteIcon(item)}</>) : (<>{item.registration} {deleteIcon(item)}</>)
                                                        )
                                                    }
                                                />

                                                <SpaceBetween direction="horizontal" size="xs" key={`BK${item.idBooking}`}>
                                                    {item.equipmentType === "GLIDER" && (

                                                        <div key={`DV${item.idBooking}`}>{towType[item.towType as keyof typeof towType]}</div>
                                                    )}
                                                    <BadgeCustom color={item.bookingTypeBadge}>{item.bookingType}</BadgeCustom>
                                                </SpaceBetween>
                                            </SpaceBetween>
                                        )
                                ),
                                width: 200
                            },
                            {
                                id: 'displayName',
                                header: <FormField label='Usuario'>Horario</FormField>,
                                minWidth: 300,
                                cell: (item: RowItem) =>
                                    item.isParent && item.children ? (
                                        <Box>
                                            <Box float="left">

                                                <h3>
                                                    <SpaceBetween size="xs" direction="horizontal">
                                                        <span key={`GT${item.idBooking.toString()}`}>{item.groupType}</span>
                                                        <Badge key={`COUNT${item.idBooking.toString()}`} color={item.children.length === 0 ? "grey" : "blue"}>
                                                            {item.children.length}
                                                        </Badge>
                                                        {item.children?.reduce((sum, child) => sum + (child.pax || 0), 0) ?? 0 > 0 ?
                                                            <Badge key={`PAX${item.idBooking.toString()}`} color="green">
                                                                {item.children?.reduce((sum, child) => sum + (child.pax || 0), 0) ?? 0}<Icon path={mdiAccountMultiple} size={0.6} />
                                                            </Badge>
                                                            : null}
                                                    </SpaceBetween>

                                                </h3>
                                            </Box>
                                            {bookingUrl !== "" && parse(date, 'dd-MM-yyyy', new Date()) >= startOfDay(new Date()) && (
                                                <Box float="right">
                                                    <Button variant="normal"
                                                        onClick={() => {
                                                            window.location.hash = `${bookingUrl}?date=${date}&idGroupType=${item.idGroupType}`
                                                        }}>
                                                        Reservar</Button>
                                                </Box>
                                            )}
                                        </Box>
                                    ) : (<SpaceBetween size="xs" direction="vertical">

                                        <FormField
                                            key={`FF${item.idBooking}`}
                                            info={
                                                <small>
                                                    <Icon path={mdiCertificateOutline} size={1} />
                                                    {` ${item.dateSubmited} ${item.timeSubmited}`}
                                                </small>
                                            }


                                            description={
                                                item.instructor ? (
                                                    <React.Fragment key={`INST${item.idBooking}`}>
                                                        <Icon path={mdiHumanMaleBoard} size={1} /> {item.instructor}
                                                    </React.Fragment>
                                                ) : null
                                            }
                                            label={
                                                item.obsBooking === "" ?
                                                    item.displayName : (
                                                        <React.Fragment key={`DF${item.idBooking}`}>
                                                            {item.displayName}
                                                            {item.pax > 0 ? <> [<Icon path={mdiAccountMultiple} size={0.6} />{item.pax}]</> : null}
                                                            <Popover

                                                                dismissButton={false}
                                                                position="top"
                                                                size="small"
                                                                header='Observaciones'
                                                                triggerType="custom"
                                                                content={item?.obsBooking}
                                                            >
                                                                {" "}
                                                                <Icon path={mdiInformation} size={0.75} />
                                                            </Popover>

                                                        </React.Fragment>
                                                    )
                                            }
                                        />
                                        {!range && (
                                            <div key={`R1${item.idBooking}`}>
                                                {item.dateStart !== item.dateEnd
                                                    ? `${item.dateStart} ${item.timeStart} - ${item.dateEnd} ${item.timeEnd}`
                                                    : `${item.dateStart} ${item.timeStart} - ${item.timeEnd}`}
                                            </div>
                                        )}

                                        {range && (
                                            <div key={`RS${item.idBooking}`}>
                                                <RangeSlider
                                                    evtEndTH={item.thresholdAfter}
                                                    evtStartTH={item.thresholdBefore}
                                                    marginVertical={0}
                                                    date={date}
                                                    evtStart={`${item.dateStart} ${item.timeStart}`}
                                                    evtEnd={`${item.dateEnd} ${item.timeEnd}`}
                                                    start={item.minBookHour}
                                                    end={item.maxBookHour}
                                                />
                                            </div>
                                        )}
                                    </SpaceBetween>
                                    )
                            },
                        ]}
                        items={tableItems}
                        trackBy={(item) => String(item.idBooking)}
                    />
                </div>
            }
            {date === "" && (
                <Box
                    margin={{ vertical: "xs" }}
                    textAlign="center"
                    color="inherit"
                >
                    <SpaceBetween size="m">
                        <b>Seleccione una fecha para consultar</b>
                    </SpaceBetween>
                </Box>
            )}
            {bookings && bookings.length === 0 && date !== "" && (
                <Box
                    margin={{ vertical: "xs" }}
                    textAlign="center"
                    color="inherit"
                >
                    <SpaceBetween size="m">
                        <b>No existen reservas en la fecha {date}</b>
                    </SpaceBetween>
                </Box>
            )}
            <ConfirmDelete show={showConfirm} confirmWord={'eliminar'} header='Se requiere confirmación' action={'Eliminar'} warning={`Se requiere su confirmación para proceder con la eliminación de la reserva ${booking?.idBooking || ""}`} onDismiss={() => setShowConfirm(false)}
                onConfirm={() => {
                    if (booking && onBookingDelete) {
                        onBookingDelete(booking);
                    }
                    setShowConfirm(false);
                }}
            />
        </SpaceBetween>
    );
};

export default TableBookings;




function setLoading(arg0: boolean) {
    throw new Error('Function not implemented.');
}

